import { getAllDashboard } from 'src/@api/dashboard'

/**
 * Extreme 升级成功后的跨页面通知。
 *
 * 背景：升级弹窗 ExtremeModal 与各功能页（text / calls / whatsapp…）解耦，
 * 扣款成功后必须先预缓冲 advanced，再广播事件让各页重拉详情读 advance。
 * 对齐 spyx：USER_SUMMARY 预缓冲 → 当前页业务接口看 advanced。
 */
export const EXTREME_UPGRADED_EVENT = 'extreme-upgraded'

/**
 * 升级后预热 advanced 状态（必须先于各功能页自己的查询）。
 *
 * 后端为节省流量：首次查询先返回缓存，同时在后台检查/同步 advanced；
 * 同步完成后，**下一次**业务查询才会返回最新 advanced。
 *
 * POST /api/dashboard/auth/all（category: USER_SUMMARY）会触发后台 advanced 同步，
 * 因此各页在拉 smsChat-summary / CALL 等接口前，必须先 await 本函数。
 *
 * @returns {Promise<void>}
 */
export async function primeExtremeAdvancedCache() {
  if (typeof window === 'undefined') return

  const mode = localStorage.getItem('currentMode') || 'iOS-Cloud'
  if (mode !== 'iOS-Cloud') return

  const username = JSON.parse(localStorage.getItem('DeviceUser') || '{}')?.username
  if (!username) return

  try {
    await getAllDashboard({
      username,
      params: {
        category: 'USER_SUMMARY'
      }
    })
  } catch (e) {
    // 预热失败不阻断后续本页拉数；页面仍可用乐观 advanced 或二次请求兜底
    console.error('[primeExtremeAdvancedCache]', e?.message || e)
  }
}

/**
 * 升级扣款成功后调用：先 USER_SUMMARY 预缓冲，再通知当前已挂载功能页重拉详情。
 * 调用方须 await，保证预缓冲完成后再关弹窗 / 刷新 UI。
 */
export const notifyExtremeUpgraded = async () => {
  if (typeof window === 'undefined') return
  await primeExtremeAdvancedCache()
  window.dispatchEvent(new CustomEvent(EXTREME_UPGRADED_EVENT))
}
